// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"64def7cb","754":"a21f38b7"}[chunkId] + ".chunk.js";
};